export default __webpack_public_path__ + "static/media/regulatory--no-overtaking--g7.30b8ee6b.png";